import React, { useState } from 'react';
import './MaterialSelect.css';

const MaterialSelect = ({ 
  label, 
  value, 
  onChange, 
  children, 
  className = "", 
  disabled = false,
  required = false,
  width = "auto"
}) => {
  const [focused, setFocused] = useState(false);
  
  const wrapperStyle = {
    width: width
  };
  
  return (
    <div 
      className={`material-select-wrapper ${className} ${(focused || value) ? 'focused' : ''} ${disabled ? 'disabled' : ''}`}
      style={wrapperStyle}
    >
      <label className="material-select-label">
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>
      <select 
        className="form-control material-select"
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        disabled={disabled}
      >
        {children}
      </select>
    </div>
  );
};

export default MaterialSelect;